module.exports = __webpack_public_path__ + "static/media/mag_pat_bes_demo.3a3f0c7c.png";